export const DEFAULT_COUNTRY_CODE = '+1'; // US, always use US phone numbers and country code is +1 always
